import React, { useEffect } from "react";
import Hero from "../components/blocks/Hero";
import StaySection from "../components/blocks/StaySection";
import GoogleReviews from "../components/blocks/GoogleReviews";
import AboutLeafStory from "../components/blocks/AboutLeafStory";
import ContactPanel from "../components/blocks/ContactPanel";
import StickyBookNow from "../components/site/StickyBookNow";
import { schemaOrgData, injectSchema } from "../utils/schemaOrg";
import useSEO, { siteNavigationSchema } from "../hooks/useSEO";

const Home = () => {
  useSEO('/');
  
  useEffect(() => {
    injectSchema(schemaOrgData.localBusiness);
    injectSchema(siteNavigationSchema);
  }, []);

  return (
    <div className="bg-[#050706]" data-testid="homepage">
      {/* Hero Section - Maximum emotional impact */}
      <Hero />

      {/* Sticky Book Now - Appears after scroll */}
      <StickyBookNow />

      {/* Main Content Sections */}
      <div className="relative">
        {/* Subtle ambient background effects */}
        <div className="pointer-events-none absolute inset-0 opacity-60 [background:radial-gradient(circle_at_20%_10%,rgba(201,162,39,0.12),transparent_45%),radial-gradient(circle_at_80%_20%,rgba(255,255,255,0.05),transparent_42%),radial-gradient(circle_at_60%_90%,rgba(14,80,52,0.15),transparent_55%)]" />
        
        <div className="relative">
          {/* Full Stay Section - Complete accommodation details */}
          <StaySection />
          
          {/* Google Reviews - Social Proof */}
          <GoogleReviews />
          
          {/* About & Philosophy */}
          <AboutLeafStory />
          
          {/* Footer Conversion & Contact */}
          <ContactPanel />
        </div>
      </div>
    </div>
  );
};

export default Home;
